import { render, staticRenderFns } from "./ProductsDescription.vue?vue&type=template&id=972d18ec&scoped=true"
import script from "./ProductsDescription.vue?vue&type=script&lang=js"
export * from "./ProductsDescription.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "972d18ec",
  null
  
)

export default component.exports